
import React from 'react';
import { Grid, Typography } from "@material-ui/core";

const ICON_NOMATCH = require("../../images/bg/nomatch.png");

export default class NoMatch extends React.Component {


    render() {
        return (
            <Grid container direction='column' alignItems='center'>
                <img src={ICON_NOMATCH} style={{ width: 175, height: 175, objectFit: 'scale-down' }}></img>
                <Typography style={{ fontSize: 12, color: '#878787' }} >暂时还没有赛事进行哦～</Typography>
            </Grid>
        );
    }
}